import React from "react";
import styled from "styled-components";
import { COLORS } from "../constants/Colors";

const StyledTypography = styled.div.attrs((props) => {
  const customColor = props.color
    ? COLORS[props.color] || props.color
    : COLORS.Dark;
  const customSize = props.size || "14px";
  const customLineHeight = props.lineHeight || "16px";
  const customFontWeight = props.isBold ? 600 : "normal";
  let customFontFamily =
    props.fontType === "heading" ? `'Mont', sans-serif` : "Open Sans";
  if (props.fontFamily) {
    customFontFamily = props.fontFamily;
  }
  const customTextAlign = props.textAlign ? props.textAlign : "left";
  return {
    customColor,
    customSize,
    customLineHeight,
    customFontWeight,
    customFontFamily,
    customTextAlign,
  };
})`
  color: ${({ customColor }) => customColor};
  font-size: ${({ customSize }) => customSize};
  font-family: ${({ customFontFamily }) => customFontFamily};
  font-weight: ${({ customFontWeight }) => customFontWeight};
  line-height: ${({ customLineHeight }) => customLineHeight};
  text-align: ${({ customTextAlign }) => customTextAlign};
`;

const Typography = (props) => {
  const {
    children,
    color,
    className,
    style,
    isBold,
    size,
    lineHeight,
    fontType,
    fontFamily,
    textAlign,
  } = props;
  return (
    <StyledTypography
      color={color}
      style={style}
      className={className}
      isBold={isBold || false}
      size={size}
      lineHeight={lineHeight}
      fontType={fontType}
      fontFamily="openSans-Regular"
      textAlign={textAlign}
    >
      {children}
    </StyledTypography>
  );
};

export default Typography;
